import type { FC } from 'react'
import type { PoolMove } from '../content/divingDads'
import { divingDadsCrew, getDadsForMove } from '../content/divingDads'

const difficultyLabel: Record<string, string> = {
  gentle: 'Gentle',
  ambitious: 'Ambitious',
  legendary: 'Legendary'
}

type MoveEntryProps = {
  readonly move: PoolMove
}

const MoveEntry: FC<MoveEntryProps> = ({ move }) => {
  const landedDads = getDadsForMove(move.id, 'completed')
  const splashOnlyDads = getDadsForMove(move.id, 'attempted')

  const scrollToDad = (dadId: string) => {
    document.getElementById(`dad-${dadId}`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    })
  }

  return (
    <article className='diving-dads-move' id={`move-${move.id}`}>
      <span
        className={`diving-dads-difficulty diving-dads-difficulty--${move.difficulty}`}
      >
        {difficultyLabel[move.difficulty]}
      </span>
      <h3 className='diving-dads-move__name'>{move.name}</h3>
      <p className='diving-dads-move__notes'>{move.notes}</p>

      {(landedDads.length > 0 || splashOnlyDads.length > 0) && (
        <div className='move-roster'>
          <p className='move-roster__label'>On the deck</p>
          <ul className='move-roster__list'>
            {landedDads.map((dad) => (
              <li key={dad.id}>
                <button
                  type='button'
                  className='dad-chip dad-chip--landed'
                  onClick={() => scrollToDad(dad.id)}
                  title={`${dad.name} landed this`}
                >
                  <span className='dad-chip__dot' aria-hidden='true' />
                  {dad.name}
                  <span className='dad-chip__badge'>landed</span>
                </button>
              </li>
            ))}
            {splashOnlyDads.map((dad) => (
              <li key={dad.id}>
                <button
                  type='button'
                  className='dad-chip dad-chip--splash'
                  onClick={() => scrollToDad(dad.id)}
                  title={`${dad.name} — splash zone`}
                >
                  <span className='dad-chip__dot' aria-hidden='true' />
                  {dad.name}
                  <span className='dad-chip__badge'>splashing</span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}

      {divingDadsCrew.some((d) => d.aspirationMoveIds.includes(move.id)) && (
        <p className='move-aspirants'>
          <span className='move-aspirants__icon' aria-hidden='true'>
            ★
          </span>
          On someone&apos;s wish list:{' '}
          {divingDadsCrew
            .filter((d) => d.aspirationMoveIds.includes(move.id))
            .map((d) => d.name)
            .join(', ')}
        </p>
      )}
    </article>
  )
}

export default MoveEntry
